import { render, staticRenderFns } from "./VendorsReport.vue?vue&type=template&id=68ecf007&scoped=true"
import script from "./VendorsReport.vue?vue&type=script&lang=js"
export * from "./VendorsReport.vue?vue&type=script&lang=js"
import style0 from "./VendorsReport.vue?vue&type=style&index=0&id=68ecf007&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ecf007",
  null
  
)

export default component.exports